<template>
    <div>
        <Header 
            :viewDeals="viewDeals" />
        
        <ModuleMenu 
            v-if="loadMenu"
            :moduleKey="module_key"
            :projectId="project_id"
            @quickViewDeals="viewDeals = !viewDeals" />

         <v-snackbar
            :timeout="feedbackDialogDuration"
            v-model="feedbackDialog"
            :color="feedbackDialogColor"
            absolute
            center
            top
            elevation="16"
            style="margin-top: 80px"
            :class="feedbackDialogColor == 'error' ? 'white--text' : 'info--text'">
            <div class="avenir_medium feedback_message" v-html="feedbackDialogMessage"></div>
        </v-snackbar>

        <div class="container_width justify-center mt-12">
            <v-row class="mx-0 px-0">
                <v-col cols="2" class="mx-0 px-0">
                    <v-card
                        class="pa-2"
                        outlined>

                        <div class="title">Filter Listings:</div>

                        <div class="mb-4">
                            <v-checkbox
                                v-model="view_status"
                                :label="active_count != null ? `${active_count} Active Listings`: `Active Listings`"
                                value="1"
                                hide-details
                                color="primary"
                                @click="filterListingsByStatus()">
                            </v-checkbox>
                            <v-checkbox
                                v-model="view_status"
                                :label="coming_count != null ? `${coming_count} Coming Soon`: `Coming Soon`"
                                value="2"
                                hide-details
                                color="primary"
                                @click="filterListingsByStatus()">
                            </v-checkbox>
                            <v-checkbox
                                v-model="view_status"
                                :label="pending_count != null ? `${pending_count} Pending Sale`: `Pending Sale`"
                                value="3"
                                hide-details
                                color="primary"
                                @click="filterListingsByStatus()">
                            </v-checkbox>
                            <v-checkbox
                                v-model="view_status"
                                :label="sold_count != null ? `${sold_count} Sold Listings`: `Sold Listings`"
                                value="4"
                                hide-details
                                color="primary"
                                @click="filterListingsByStatus()">
                            </v-checkbox>
                        </div>

                        <v-select
                            v-model="view_types"
                            :items="listing_types"
                            label="Practice Types"
                            class="font-weight-light"
                            multiple
                            @change="filterListingsByStatus()"
                        ></v-select>

                        <v-select
                            v-model="aum_range"
                            :items="aum_ranges"
                            label="AUM"
                            class="font-weight-light"
                            multiple
                            @change="filterListingsByStatus()"
                        ></v-select>

                        <v-select
                            v-model="loc_regions"
                            :items="listing_regions"
                            label="Regions"
                            class="font-weight-light"
                            multiple
                            @change="filterListingsByStatus()"
                        ></v-select>

                        <div class="d-block mt-6 mb-2 text-center">
                            <!-- <v-btn dark outlined color="primary" @click="filterListingsByStatus()">Apply Filters</v-btn> -->
                            <v-btn
                                outlined
                                color="primary"
                                class="text-capitalize caption my-2"
                                @click="resetFilter()">
                                Reset filter
                            </v-btn>
                        </div>

                    </v-card>
                </v-col>

                <v-col cols="10" class="mx-0 pl-6 pr-0">
                    <v-alert
                        v-if="readyToLoadListings && this.buyer && this.buyer.status !== 'completed'"
                        icon="mdi-bullhorn-variant"
                        border="right"
                        color="secondary"
                        text
                        outlined
                        prominent
                        class="ml-3 mb-6 sansation_subtitle font-weight-medium">
                        Complete your <router-link :to="`/module_questionnaire/${module_key}/${project_id}`" push class="secondary--text text--darken-1">buyer profile</router-link> to be eligible to express interest on listings
                    </v-alert>

                    <div class="body-2 px-3 mx-0" v-if="readyToLoadListings">
                        <ListingFilters
                            :FilterChips="filterChips"
                            @TriggerFilters="triggerFilters = !triggerFilters"
                        />
                    </div>
                    <v-card v-if="!readyToLoadListings"
                        flat
                        class="d-flex justify-center py-12"
                        style="background-color: #EFEFEF"
                    >
                        <v-progress-circular
                            indeterminate
                            color="primary"
                            class="my-12"
                            size="80"
                            width="4">
                        </v-progress-circular>

                    </v-card>

                    <v-card v-if="noListingsToShow"
                        flat
                        class="d-flex justify-center py-12"
                        style="background-color: #EFEFEF"
                    >
                        <div class="d-flex justify-center py-12">
                            Welp! Looks like there aren't any listings to show under this combination of filters.
                        </div>
                    </v-card>

                    <div v-if="readyToLoadListings && !noListingsToShow">
                        <v-layout wrap class="px-0 mx-0">
                            <v-col
                                v-for="item in filteredListings"
                                :key="item.id"
                                cols="4"
                                class="justify-space-between pr-0"
                            >
                                <v-card tile class="mx-0 px-0">
                                    <router-link :to="`/buyer_listings/${item.listing_id}`" push class="button_link">
                                        <v-img class="d-flex mx-0 px-0" :src="item.img"></v-img>
                                        <div class="d-flex d-inline" style="width: 100%">
                                            <div v-if="insuranceBasedListings.includes(item.listing_type)" alt="COMMISSION" style="height: 74px; width: 35%;" class="d-flex flex-column align-center justify-center white--text error text-center">
                                                <div v-if="item.revenue_average_fee_charged == null" class="d-block body-1 font-weight-bold px-1">&mdash;</div>
                                                <div v-else class="d-block body-1 font-weight-bold px-1">{{ item.revenue_average_fee_charged | currency(false, false) }}</div>
                                                <div class="d-block px-1" style="line-height: 1">Avg Commission</div>
                                            </div>
                                            <div v-else-if="taxBasedListings.includes(item.listing_type)" :alt="item.asset_label" style="height: 74px; width: 35%;" class="d-flex flex-column align-center justify-center white--text error text-center">
                                                <div v-if="item.asset_value == null" class="d-block body-1 font-weight-bold px-1">&mdash;</div>
                                                <div v-else class="d-block body-1 font-weight-bold px-1">{{ item.asset_value | currency(false, false) }}</div>
                                                <div class="d-block px-1" style="line-height: 1">{{ item.asset_label }}</div>
                                            </div>
                                            <div v-else alt="AUM" style="height: 74px; width: 28%;" class="d-flex flex-column align-center justify-center white--text error text-center">
                                                <div v-if="item.aum === null" class="d-block body-1 font-weight-bold px-1">&mdash;</div>
                                                <div v-else class="d-block body-1 font-weight-bold px-1">{{ item.aum | currency(false, false) }}</div>
                                                <div class="d-block px-1">AUM</div>
                                            </div>

                                            <div alt="Revenue" style="height: 74px;" :style="item.listing_type == 8 ? 'width: 30%' : 'width: 32%'" class="d-flex flex-column align-center justify-center white--text secondary text-center">
                                                <div v-if="item.revenue === null" class="d-block body-1 font-weight-bold px-1">&mdash;</div>
                                                <!-- <div v-else class="d-block body-1 font-weight-bold px-1">{{ item.revenue | currency(false, false)  }}</div> -->
                                                <div v-else class="d-block body-1 font-weight-bold px-1">{{ item.revenue }}</div>
                                                <div class="d-block px-1">Revenue</div>
                                            </div>

                                            <div alt="Type of Listing" style="height: 74px" :style="item.listing_type == 8 ? 'width: 35%' : 'width: 40%'" class="d-flex flex-column align-center justify-center white--text primary text-center">
                                                <div v-if="item.type_name == '[Not Defined]'" class="d-block body-1 font-weight-medium px-1">
                                                    &mdash;<br>
                                                    <div class="d-block px-1">Practice Type</div>
                                                </div>
                                                <div v-else class="d-block body-1 font-weight-medium px-1">{{ item.type_name }}</div>
                                            </div>
                                        </div>
                                    </router-link>

                                    <v-card-text>
                                        <div class="d-flex justify-space-between">
                                            <div class="d-inline">
                                                <div class="listing_header d-block">{{ item.listing_id }}</div>
                                                <span class="listing_header_secondary d-block" v-html="`Status: ${item.status_name}`"></span>
                                            </div>

                                                <v-icon v-if="item.interested" large :color="'#97c131'">{{ icons.interestCheck }}</v-icon>

                                        </div>

                                        <div class="d-flex justify-space-between">
                                            <!-- <v-btn v-if="!item.offer_made" text :color="item.interest_type" @click="updateListing(item.id, 'interest')" class="d-inline">{{ item.interest_text }}</v-btn>
                                            <v-btn v-if="item.offer_made" text :color="item.interest_type" class="d-inline">{{ item.interest_text }}</v-btn> -->
                                            <!-- <router-link :to="`/buyer_listings/${item.listing_id}`" push class="button_link"><div class="mt-4 view_listing primary--text">View Listing</div></router-link> -->
                                            <!-- <v-btn icon @click.native="showDesc(item)" class="mt-2">
                                                <v-icon>{{ item.show ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                                            </v-btn> -->
                                        </div>
                                    </v-card-text>

                                    <v-slide-y-transition>
                                        <v-card-text v-show="item.show" v-html="item.description" style="border-top: 1px solid #ccc" class="mt-2"></v-card-text>
                                    </v-slide-y-transition>
                                </v-card>
                            </v-col>
                        </v-layout>
                    </div>
                </v-col>
            </v-row>

            <v-row class="mx-12">
                <v-col cols="12" class="mx-12">&nbsp;</v-col>
            </v-row>
            <!-- <div class="my-12 d-flex justify-end">
                <v-btn class="elevation-0" color="success" style="color:#36480B; text-weight:900">
                    <v-icon large color="secondary">{{ icons.weChat }}</v-icon>Chat with us
                </v-btn>
            </div> -->
        </div>
    </div>
</template>

<script>
    import axios from "axios";
import Cookie from "js-cookie";
    import appUrls from '../helpers/environment';
    import { mdiMagnify, mdiChevronDown, mdiChevronUp, mdiHeartCircleOutline, mdiHeart, mdiWechat, mdiEmailVariant, mdiCheckboxMarkedCircle } from '@mdi/js'

    import Header from './Header'
    import ModuleMenu from './ModuleMenu'
    import ListingFilters from './ListingFilters'
    import { toDollarsListings } from './utilities';

    export default {
        name: 'Listings',
        components: {
            Header,
            ModuleMenu,
            ListingFilters
        },

        data () {
            return {
                project_id: '',
                module_key: 'buyer',
                buyer: {},
                readyToLoadListings: false,
                noListingsToShow: false,
                loadMenu: false,
                // header_text: 'Seller Listings',
                listings: [],
                filteredListings: [],
                active_listings: true,
                feedbackDialog: false,                
                feedbackDialogColor: 'success',
                feedbackDialogMessage: '',
                feedbackDialogDuration: 10000,
                icons: {
                    chevronDownIcon: mdiChevronDown,
                    chevronUpIcon: mdiChevronUp,
                    magnifyIcon: mdiMagnify,
                    heartIcon: mdiHeart,
                    heartCircleIcon: mdiHeartCircleOutline,
                    weChat: mdiWechat,
                    socailEmail: mdiEmailVariant,
                    interestCheck: mdiCheckboxMarkedCircle
                },
                listing_statuses: [
                    { value: 1, text: 'Active' },
                    { value: 2, text: 'Coming Soon' },
                    { value: 3, text: 'Pending' },
                    { value: 4, text: 'Sold' },
                ],
                listing_types: [],
                aum_ranges: [
                    { value: 1, text: '$1M - $50M' },
                    { value: 2, text: '$50M - $200M' },
                    { value: 3, text: '$200M +' },
                ],
                listing_regions: [],

                view_status: 'view_status' in sessionStorage ? sessionStorage.getItem('view_status').split(',') : [1,2,4],
                view_types: 'view_types' in sessionStorage ? sessionStorage.getItem('view_types').split(',') : [],
                aum_range: 'aum_range' in sessionStorage ? sessionStorage.getItem('aum_range').split(',') : [],
                loc_regions: 'loc_regions' in sessionStorage ? sessionStorage.getItem('loc_regions').split(',') : [],

                filterChips: [],
                triggerFilters: false,

                viewDeals: false,
                
                active_count: null,
                coming_count: null,
                pending_count: null,
                sold_count: null,

                authUser: {
					id: String
				},
                insuranceBasedListings: [8], // 3,7
                taxBasedListings: [10],
            }
        },
        watch: {
            dialog (val) {
                val || this.close()
            },

            listings () {
              this.filterListingsByStatus();
            },
            
            filteredListings (arr) {
                this.noListingsToShow = false;
                this.readyToLoadListings = false;
                if(arr.length == 0){
                    setTimeout(() => {
                        this.readyToLoadListings = true;
                        this.noListingsToShow = true;
                    }, 1500);
                    //this.readyToLoadListings = false;
                } else {
                    this.readyToLoadListings = true;
                    this.noListingsToShow = false;
                }
            },
            
            triggerFilters () {
                // this function is called when a filter chip gets removed
                // we will use the remaining filter chips to repopulate the filter panel, then call the filter function

                // Remove all filters from app state
                this.view_status = []
                this.view_types = []
                this.loc_regions = []
                this.aum_range = []

                sessionStorage.removeItem('view_status')
                sessionStorage.removeItem('view_types')
                sessionStorage.removeItem('loc_regions')
                sessionStorage.removeItem('aum_range')

                // repopulate the filters based on the remaining filterchips
                // first the side panel
                this.filterChips.map((chip) => {
                    const filterCategory = chip.split(':')[0];
                    const filterId = chip.split(':')[1];
                    if (Array.isArray(this[filterCategory])) {
                        this[filterCategory].push(filterId);
                    } else {
                        this[filterCategory] = filterId;
                    }
                });

                // then the session
                if (this.view_status.length) sessionStorage.setItem('view_status', this.view_status);
                if (this.view_types.length) sessionStorage.setItem('view_types', this.view_types);
                if (this.loc_regions.length) sessionStorage.setItem('loc_regions', this.loc_regions);
                if (this.aum_range.length) sessionStorage.setItem('aum_range', this.aum_range);

                // run query again
                this.filterListingsByStatus()
            }
        },
        
        created () {
            document.title = 'SRG myCompass: Buyer Listings'
            this.getLists()
            this.getProjectId()
        },
        
        mounted () {
            this.urlErrorCheck()

            setTimeout(() => {
                this.getListings()
            }, 3000);

        },
        methods: {
            checkUser: async function () {
				await axios.get(`${appUrls.api}/api/user_check`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                })
                .then( res => {
                    if(res.data.outcome) {    
						this.authUser.id = res.data.user_data.id
                    } else {
						console.log(res.data.message)
					}
                })
                .catch(function (error) {
                    console.log(error);
                });
			},

            getLists: async function () {
                let optionsLists = [
                    {'name': 'listing_types', 'type': 'int'},
                    {'name': 'states_and_regions', 'type': 'txt'}
                ];

                await axios.post(`${appUrls.api}/api/lists`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    list_options: optionsLists
                })
                .then( res => {
                    //console.log(res.data)
                    if(res.data.outcome){
                        let arrLists = res.data.lists;
                        // SET PROPERTIES WITH THIER APPROPRIATE LIST
                        for (let l in arrLists) {
                            if (arrLists[l].name == 'states_and_regions') this.listing_regions = arrLists[l].list.slice(1, arrLists[l].list.length)
                            if (arrLists[l].name == 'listing_types') this.listing_types = arrLists[l].list
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            urlErrorCheck: function () {
                if ( this.$route.query ) {
                    if ( this.$route.query.error == 'listing_not_found' ) {
                        this.feedbackDialog = true;
                        this.feedbackDialogColor = 'error';
                        this.feedbackDialogMessage = 'Hmmm, that particular listing couldn&apos;t be found.<br>Look through our listings to find more to express interest on!';
                    }
                }
            },
            
            getProjectId: async function () {
                await this.checkUser()
                await axios.get(`${appUrls.api}/api/module_projects/${this.module_key}/${this.authUser.id}`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                })
                .then( res => {
                    if(res.data.outcome){
                        this.project_id = res.data.project_data.project_id;
                        this.module_id = res.data.project_data.module_id;
                        this.loadMenu = true
                        this.getCurrentProject()
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            getCurrentProject: async function () {
                await axios.get(`${appUrls.api}/api/current_project/${this.project_id}/${this.authUser.id}`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                })
                .then( res => {
                    // console.log('details', res.data.details)
                    if(res.data.outcome){
                        this.buyer = res.data.details;

                        setTimeout(() => {
                            this.readyToLoad = true;
                            // if( this.buyer.status === 'review' ) this.under_review = true;
                        }, 1500);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            getListings: async function () {                
                await axios.post(`${appUrls.api}/api/listings`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    data: {
                        'user_id': this.authUser.id
                    }
                })
                .then( res => {
                    if(res.data.outcome && res.data.listings.length) {
                        //console.log()
                        this.listings = res.data.listings;

                        let i = 0;
                        for( let listing of this.listings ) {
                            // this.listings[i].post_date    = dateFormat(listing.post_date, "mm/dd/yyyy");
                            this.listings[i].post_date    = this.listings[i].post_date.substr(0, 10);
                            this.listings[i].listing_type = this.listings[i].listing_type != undefined ? parseInt(this.listings[i].listing_type) : 0;
                            this.listings[i].status       = parseInt(this.listings[i].status);
                            this.listings[i].title        = this.listings[i].title != undefined ? this.listings[i].title : '[No Title]';

                            // LOCATION MODIFICATION
                            let vLoc = ''
                            if (listing.city && listing.state) {
                              vLoc = `${listing.city}, ${listing.state}`
                            }
                            if ((!listing.city && listing.state) || (listing.city && !listing.state)) {
                              vLoc = listing.state || listing.city
                            }
                            this.listings[i].location = vLoc

                            // AVERAGE COMMISSION & AUM + AUA LABEL
                            if ( this.insuranceBasedListings.includes(this.listings[i].listing_type) ) {
                                this.listings[i].asset_label = 'Average Commission'
                            } else if ( this.taxBasedListings.includes(this.listings[i].listing_type) ) {
                                if ( this.listings[i].aum && this.listings[i].aua )       this.listings[i].asset_label = 'AUM + AUA'
                                else if ( this.listings[i].aum && !this.listings[i].aua ) this.listings[i].asset_label = 'AUM'
                                else if ( !this.listings[i].aum && this.listings[i].aua ) this.listings[i].asset_label = 'AUA'
                            } else if ( this.listings[i].aum ) {
                                this.listings[i].asset_label = 'AUM'
                            }
                            
                            // AVERAGE COMMISSION & AUM + AUA VALUE
                            if ( this.insuranceBasedListings.includes(this.listings[i].listing_type) ) {
                                this.listings[i].asset_value = this.listings[i].revenue_average_fee_charged
                            } else if ( this.taxBasedListings.includes(this.listings[i].listing_type) ) {
                                if ( this.listings[i].aum && this.listings[i].aua )             this.listings[i].asset_value = JSON.parse(this.listings[i].aum)+JSON.parse(this.listings[i].aua)
                                else if ( this.listings[i].aum && !this.listings[i].aua )   this.listings[i].asset_value = this.listings[i].aum
                                else if ( !this.listings[i].aum && this.listings[i].aua )   this.listings[i].asset_value = this.listings[i].aua
                            } else if ( this.listings[i].aum ) {
                                this.listings[i].asset_value = this.listings[i].aum
                            }

                            // REVENUE TEXT
                            let rev_text
                            if ( this.listings[i].revenue_t12_months !== null ) {
                                if (Number.parseFloat(this.listings[i].revenue_t12_months) >= 1000000) {
                                    rev_text = Number.parseFloat(this.listings[i].revenue_t12_months / 1000000).toFixed(2)
                                    this.listings[i].revenue = '$'+rev_text.replace(/\.?0*$/,'')+'M'
                                } else {
                                    this.listings[i].revenue = toDollarsListings(Number.parseFloat(this.listings[i].revenue_t12_months))
                                }
                            } else {
                                if ( this.listings[i].revenue !== null ) {
                                    if (Number.parseFloat(this.listings[i].revenue) >= 1000000) {
                                        rev_text = Number.parseFloat(this.listings[i].revenue / 1000000).toFixed(2)
                                        this.listings[i].revenue = '$'+rev_text.replace(/\.?0*$/,'')+'M'
                                    }else{
                                        this.listings[i].revenue = toDollarsListings(Number.parseFloat(this.listings[i].revenue))
                                    }
                                }
                            }

                            // IMAGE
                            if (this.listings[i].custom_image != null ) {
                                this.listings[i].img = require(`@/assets/listings/custom/${this.listings[i].custom_image}`);
                            } else {
                                this.listings[i].img = require(`@/assets/listings/states/${this.listings[i].state}.jpg`);
                            }

                            // STATUS
                            let statusObj = this.listing_statuses.find(obj => parseInt(obj.value) === this.listings[i].status);
                            this.listings[i].status_name = this.listings[i].status != 0 ? statusObj.text : '[Not Defined]';

                            // ACCEPTING APPLICATIONS
                            this.listings[i].accepting_applications = this.listings[i].accepting_flag ? 'Accepting Applications' : 'Not Accepting Applications'

                            // TYPE NAME
                            let typeObj = this.listing_types.find(obj => parseInt(obj.value) === this.listings[i].listing_type);
                            this.listings[i].type_name = this.listings[i].listing_type != 0 ? typeObj.text : '[Not Defined]';

                            // LOOK TO SEE IF THERE IS EVEN ANY RECORDS IN jbuyerstolistings FOR THIS USER & LISTING
                            let has_record = res.data.actions.find(row => row.listing_id === this.listings[i].id) ? true : false;
                            let interest_record = has_record ? res.data.actions.find(row => row.listing_id === this.listings[i].id) : false;

                            // INTERESTED
                            // console.log('has_record: '+has_record)
                            this.listings[i].interested     = has_record ? interest_record.interest ? true : false : false;
                            this.listings[i].interest_type  = has_record ? interest_record.interest ? "error" : "primary" : "primary";
                            this.listings[i].interest_text  = has_record ? interest_record.interest ? "Retract Interest" : "Express Interest" : "Express Interest";

                            // OFFER
                            //console.log('interest_record.offer: '+interest_record.offer)
                            this.listings[i].offer_made = interest_record ? interest_record.offer ? true : false : false;
                            this.listings[i].offer_type = interest_record ? interest_record.offer ? "error" : "primary" : "primary";
                            this.listings[i].offer_text = interest_record ? interest_record.offer ? 'Offer Made' : 'Make An Offer' : 'Make An Offer';

                            // FAV
                            this.listings[i].fav        = interest_record ? interest_record.fav ? true : false : false;
                            this.listings[i].fav_color  = interest_record ? interest_record.fav ? "warning" : "#999" : "#999";

                            i++;
                        }
                        // console.log(this.listings)
                        //this.filterListingsByStatus()
                        // let vs = sessionStorage.getItem('view_status') != null ? sessionStorage.getItem('view_status').split(',').map(Number) : null
                        // for ( let item of this.listings ) {
                        //     if ( vs !== null ) {
                        //         if( vs.includes(item.status) ) {
                        //             this.view_status.push(item.status)
                        //         }
                        //     } else {
                        //         this.view_status.push(item.status)
                        //     }
                        // }
                        // let view_status = [...new Set(this.view_status.map(Number))]
                        // this.view_status = view_status.sort().map(String)

                        // SORT LISTINGS STATUS, THEN BY POST_DATE
                        this.listings.sort((a, b) => (a.status > b.status) ? 1 : (a.status === b.status) ? ((a.post_date < b.post_date) ? 1 : -1) : -1 )

                        this.active_count  = this.listings.filter(book => book.status == 1).length
                        this.coming_count  = this.listings.filter(book => book.status == 2).length
                        this.pending_count = this.listings.filter(book => book.status == 3).length
                        this.sold_count    = this.listings.filter(book => book.status == 4).length

                    } else {
                        this.readyToLoadListings = true;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            filterListingsByStatus () {
                this.readyToLoadListings = false;
                this.filteredListings = this.listings;
                this.filterChips = []

                // LISTING STATUS - view_status ///////////////////////////////////////////////////////
                if (this.view_status.length) {
                    sessionStorage.setItem('view_status', this.view_status)
                    var vs = this.view_status.map(Number);
                    this.filteredListings = this.filteredListings.filter(row => {
                        return vs.includes(parseInt(row.status))
                    });
                    for ( let item of vs ) {
                      let statusObj = this.listing_statuses.find(obj => parseInt(obj.value) === parseInt(item));
                      if (!this.filterChips.includes('view_status:'+statusObj.value+':'+statusObj.text)) this.filterChips.push('view_status:'+statusObj.value+':'+statusObj.text)
                    }
                    this.view_status = [... new Set(vs)].map(String);
                }

                // LISTING PRACTICE TYPES - view_types ///////////////////////////////////////////////////////
                if (this.view_types.length) {
                    sessionStorage.setItem('view_types', this.view_types)
                    let pr_types = [];
                    for ( let item of this.view_types ) {
                        pr_types.push(parseInt(item));
                    }

                    this.filteredListings = this.filteredListings.filter(row => {
                        return pr_types.includes(parseInt(row.listing_type));
                    });

                    for( let item of pr_types ) {
                        let typeObj = this.listing_types.find(obj => parseInt(obj.value) === parseInt(item));
                        if(!this.filterChips.includes('view_types:'+typeObj.value+':'+typeObj.text)) this.filterChips.push('view_types:'+typeObj.value+':'+typeObj.text)
                    }
                    this.view_types = pr_types
                }

                // LISTING AUM RANGES - aum_range MULTI SELECT ///////////////////////////////////////////////////////
                if (this.aum_range.length) {
                    sessionStorage.setItem('aum_range', this.aum_range)
                    let ar_brackets = [];
                    for ( let item of this.aum_range ) {
                        ar_brackets.push(parseInt(item));
                    }

                    this.filteredListings = this.filteredListings.filter(row => {
                        return  ( ar_brackets.includes(1) && (row.aum >= 1000000 && row.aum < 50000000) ) || 
                                ( ar_brackets.includes(2) && (row.aum >= 50000000 && row.aum < 200000000) ) || 
                                ( ar_brackets.includes(3) && row.aum >= 200000000 ) 
                    });

                    for( let item of ar_brackets ) {
                        let rangeObj = this.aum_ranges.find(obj => parseInt(obj.value) === parseInt(item));
                        if(!this.filterChips.includes('aum_range:'+rangeObj.value+':'+rangeObj.text)) this.filterChips.push('aum_range:'+rangeObj.value+':'+rangeObj.text)
                    }
                    this.aum_range = ar_brackets
                }

                // LISTING REGION - loc_regions ///////////////////////////////////////////////////////
                if (this.loc_regions.length) {
                    sessionStorage.setItem('loc_regions', this.loc_regions)
                    let region_states = []; //,
                        //region_text   = [];
                    for( let item of this.loc_regions ) {
                        switch (item) {
                            case 'region-nw':           region_states = region_states.concat(['WA', 'OR', 'ID']);
                                                        if(!this.filterChips.includes('loc_regions:region-nw:Northwest')) this.filterChips.push('loc_regions:region-nw:Northwest');         break;
                            case 'region-sw':           region_states = region_states.concat(['UT', 'CO', 'AZ', 'NM']);
                                                        if(!this.filterChips.includes('loc_regions:region-sw:Southwest')) this.filterChips.push('loc_regions:region-sw:Southwest');         break;
                            case 'region-w':            region_states = region_states.concat(['CA', 'NV']);
                                                        if(!this.filterChips.includes('loc_regions:region-w:West')) this.filterChips.push('loc_regions:region-w:West');                   break;
                            case 'region-rockies':      region_states = region_states.concat(['MT', 'WY', 'ND', 'SD', 'NE']);
                                                        if(!this.filterChips.includes('loc_regions:region-rockies:Rockies')) this.filterChips.push('loc_regions:region-rockies:Rockies');             break;
                            case 'region-s':            region_states = region_states.concat(['TX', 'KS', 'OK', 'AR', 'LA']);
                                                        if(!this.filterChips.includes('loc_regions:region-s:South')) this.filterChips.push('loc_regions:region-s:South');                 break;
                            case 'region-midwest':      region_states = region_states.concat(['MN', 'IA', 'WI', 'MI']);
                                                        if(!this.filterChips.includes('loc_regions:region-midwest:Midwest')) this.filterChips.push('loc_regions:region-midwest:Midwest');             break;
                            case 'region-ohio-valley':  region_states = region_states.concat(['MO', 'IL', 'IN', 'OH', 'KY', 'TN']);
                                                        if(!this.filterChips.includes('loc_regions:region-ohio-valley:Ohio Valley')) this.filterChips.push('loc_regions:region-ohio-valley:Ohio Valley');     break;
                            case 'region-se':           region_states = region_states.concat(['AL', 'GA', 'FL', 'SC', 'NC']);
                                                        if(!this.filterChips.includes('loc_regions:region-se:Southeast')) this.filterChips.push('loc_regions:region-se:Southeast');         break;
                            case 'region-atlantic':     region_states = region_states.concat(['VA', 'WV', 'DC', 'MD', 'DE', 'NY', 'NJ', 'PA']);
                                                        if(!this.filterChips.includes('loc_regions:region-atlantic:Atlantic')) this.filterChips.push('loc_regions:region-atlantic:Atlantic');           break;
                            case 'region-ne':           region_states = region_states.concat(['CT', 'RI', 'MA', 'VT', 'NH', 'ME']);
                                                        if(!this.filterChips.includes('loc_regions:region-ne:Northeast')) this.filterChips.push('loc_regions:region-ne:Northeast');         break;
                        }
                    }
                    this.filteredListings = this.filteredListings.filter(row => {
                        return region_states.length ? region_states.includes(row.state) : true;
                    });
                }

                this.active_count  = this.filteredListings.filter(book => book.status == 1).length
                this.coming_count  = this.filteredListings.filter(book => book.status == 2).length
                this.pending_count = this.filteredListings.filter(book => book.status == 3).length
                this.sold_count    = this.filteredListings.filter(book => book.status == 4).length
                //console.log(this.filteredListings)
                this.readyToLoadListings = true;
            },

            resetFilter () {
                this.view_status = [1,2,4]
                this.view_types = []
                this.aum_range = []
                this.loc_regions = []
                this.filterChips = []

                sessionStorage.removeItem('view_status')
                sessionStorage.removeItem('view_types')
                sessionStorage.removeItem('aum_range')
                sessionStorage.removeItem('loc_regions')

                this.getListings();
            },

            showDesc (item) {
                // console.log(item)
                this.$set(this.filteredListings[this.filteredListings.indexOf(item)], 'show', !item.show);
                //console.log(this.filteredListings)
            },

            updateListing ( listingId, action ) {
                axios.post(`${appUrls.api}/api/update_listing`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    data: {
                        'user_id': Cookie.get('id'),
                        'listing_id': listingId,
                        'action': action
                    }
                })
                .then( res => {
                    //console.log(res.data.message)
                    this.getListings()
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: 200;
    }

    label {
        font-weight: 500;
        text-decoration-line: underline;
    }

    .feedback_message {
        margin:0 auto; 
        padding: 6px 12px; 
        font-size: 1.1rem; 
        text-align: center;
        line-height: 1.4rem;
    }

    a.button_link {
        text-decoration-line: none
    }

    .listing {
        min-height: 70vh;
    }
    .listing_header {
        font-size: 1.2em;
        font-weight: normal;
        color: #000;
    }
    .listing_header_secondary {
        font-size: 1em;
        font-weight: normal;
        color: #909090;
    }
    .listing_header_tir {
        font-size: 1em;
        font-weight: normal;
        color: #909090;
    }
    .buyer_download_image {
        width:497px;
        height:426px;
        background-image: url('https://www.successionresource.com/wp-content/uploads/2018/05/SRG_Succession-Planning-Case-Study.png');
        background-position: right -50px;
        background-size: contain;
    }
    .view_listing {
        /* color:#0096a6;  */
        font-size: 1.2em;
        text-transform: uppercase
    }

    .green-box-img {
      transform: translateY(6px);
      margin-right: 10px;
      width: 28px;
      height: 28px;
      display: inline-block;
    }
</style>



// WEBPACK FOOTER //
// src/components/Listings.vue